import { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { useSite } from "../context/SiteContext";
import { Phone, MessageCircle } from "lucide-react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Apartments from "../components/site/Apartments";
import Amenities from "../components/site/Amenities";
import Gallery from "../components/site/Gallery";
import Location from "../components/site/Location";
import BookingEngine from "../components/site/BookingEngine";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import CookieConsent from "../components/site/CookieConsent";
import { trackWhatsappClick, trackPhoneClick } from "../lib/analytics";

export default function HomePage() {
  const { lang } = useLang();
  const { site } = useSite();
  const [bookingApt, setBookingApt] = useState("");

  const onBook = (id) => {
    setBookingApt(id);
    setTimeout(() => {
      const el = document.getElementById("booking");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  const waMsg = encodeURIComponent(
    lang === "el"
      ? "Γειά σας! Ενδιαφέρομαι για κράτηση."
      : "Hello! I'd like to book."
  );

  return (
    <div className="overflow-hidden">
      <Navbar />
      <Hero />
      <Apartments onBook={onBook} />
      <Amenities />
      <Gallery />
      <Location />
      <BookingEngine initialApartment={bookingApt} />
      <Contact />
      <Footer />
      <CookieConsent />

      {/* Floating CTA */}
      <div className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 z-40 flex flex-col gap-2 sm:gap-3">
        <a
          href={`https://wa.me/${site.whatsapp}?text=${waMsg}`}
          target="_blank"
          rel="noreferrer"
          data-testid="floating-whatsapp"
          onClick={trackWhatsappClick}
          className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
          aria-label="WhatsApp"
        >
          <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6" />
        </a>
        <a
          href={`tel:${site.phone}`}
          data-testid="floating-call"
          onClick={trackPhoneClick}
          className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#1A2B4C] text-white shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
          aria-label="Call"
        >
          <Phone className="w-5 h-5" />
        </a>
      </div>
    </div>
  );
}
